import { BillingConfig } from '../types/billing'

const show = (v: unknown): string => {
  if (v === undefined || v === null || v === '') return '(blank)'
  if (typeof v === 'boolean') return v ? 'on' : 'off'
  if (Array.isArray(v)) return v.length > 6 ? `${v.length} entries` : v.map((x) => (typeof x === 'object' ? (x as { name?: string; id?: string }).name ?? (x as { id?: string }).id ?? '…' : String(x))).join(', ') || '(none)'
  if (typeof v === 'object') return '…'
  const s = String(v)
  return s.length > 60 ? `${s.slice(0, 57)}…` : s
}

/** Human-readable list of what a settings patch changes — stored in the billing audit trail. */
export function describeConfigChanges(current: BillingConfig, patch: Partial<BillingConfig>): string[] {
  const out: string[] = []
  const walk = (path: string, before: unknown, after: unknown) => {
    if (JSON.stringify(before) === JSON.stringify(after)) return
    const bothObjects = before && after && typeof before === 'object' && typeof after === 'object' && !Array.isArray(before) && !Array.isArray(after)
    if (bothObjects) {
      const keys = new Set([...Object.keys(before as object), ...Object.keys(after as object)])
      keys.forEach((k) => walk(`${path}.${k}`, (before as Record<string, unknown>)[k], (after as Record<string, unknown>)[k]))
      return
    }
    if (Array.isArray(before) && Array.isArray(after) && before.every((x) => x && typeof x === 'object')) {
      after.forEach((item, i) => {
        const id = (item as { id?: string }).id
        const prev = before.find((b) => (b as { id?: string }).id === id) ?? before[i]
        if (!prev) out.push(`${path}: added ${show([item])}`)
        else walk(`${path}[${(item as { name?: string }).name ?? id ?? i}]`, prev, item)
      })
      before.forEach((b) => {
        const id = (b as { id?: string }).id
        if (id && !after.some((a) => (a as { id?: string }).id === id)) out.push(`${path}: removed ${show([b])}`)
      })
      return
    }
    out.push(`${path}: ${show(before)} → ${show(after)}`)
  }
  ;(Object.keys(patch) as (keyof BillingConfig)[]).forEach((k) => walk(k, current[k], patch[k]))
  return out
}
